module.exports = __webpack_public_path__ + "img/pic_HualienCounty.8abb4f3c.jpg";